import { Building2 } from 'lucide-react';
import type { NavItem } from './types';

/**
 * The «Empresas» destination (§4.12), view 18. It carries NO second level even
 * though the feature has six views: the other five (20-23, with 20 having no
 * route of its own) belong to ONE specific company and live as tabs/actions of
 * the detail (`companies/:id`, `routes/companies.routes.tsx`). The menu cannot
 * offer «CAFs» without knowing whose — unlike «Webhooks» (`webhooks.nav.ts`),
 * which grew a second level because its children («Entregas fallidas»,
 * «Historial de eventos») do not depend on an id chosen beforehand, this destination
 * NEVER gets `children`: there is no way for a menu item to "know" which
 * company to show.
 */
export const companiesNav: readonly NavItem[] = [
  { label: 'Empresas', to: '/companies', icon: Building2, group: 'setup' },
];
